import type { FaireProductEntity } from "../../entity_types/product";

export const p_xaz49bd4e7: FaireProductEntity = {
  token: "p_xaz49bd4e7",
  type: "product",
  name: "Meditating Buddha Statue - 18In High",
  brandToken: "b_6clm7lye",
  brandName: "Hi-Line Gift Ltd.",
  imageUrl: "https://cdn.faire.com/fastly/82cab9f682bee50f1c84c928ad676d34b29eeeff6a3c113d57978d3fec8adb1a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0e827b28d104db2693158d690506826858309e274198841409d65e33b1b3b64a.jpeg"
  ],
  priceDollars: 80,
  description: "Tune into zen and tranquility with this detailed 18in buddha statue. Place it in your home or garden and create a space for relaxation and meditation. Finely crafted detail.",
  tags: [],
  msrpDollars: 174,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:52.384Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
